import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { IDashboard, IDropDown, IDropDownItem } from "../interfaces/idashboard";
import { ICountryMap } from "../interfaces/icountrymap";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";

@Injectable()
export class DashboardService extends BaseService {

    constructor(private applicationSettingsService: ApplicationSettingsService,
        http: HttpClient,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    getDashboard(): Observable<IDashboard> {
        const url = `${this.applicationSettingsService.apiUrl}Dashboard/`;      
        return super.get(url)
            .pipe(map((r: any) => r as IDashboard));
    }

    getDataForMap(dropDownsToRender: IDropDown[], keySelected: number | null): ICountryMap[] {
        let dataTable: any[] = new Array();
        for (let dropDown of dropDownsToRender) {
            if (dropDown.presentationTypeId === 2) {
                // this is a key so we know that there is data associated for the map
                for (let countryDesc of dropDown.countryDescriptions) {
                    if (keySelected != null && countryDesc.dropDownItemId !== keySelected) {
                        continue;
                    }
                    let colourToUse: string = dropDown.dropDownItems.filter(function (d: IDropDownItem): any {
                        return d.id === countryDesc.dropDownItemId;
                    })[0].colour;
                    let country: ICountryMap = {
                        countryName: countryDesc.countryName,
                        countryCode: countryDesc.countryCode,
                        countryValue: countryDesc.dropDownItemId,
                        text: countryDesc.text,
                        colour: colourToUse
                    } as ICountryMap;
                    dataTable.push(country);
                }
                break;
            }
        }
        return dataTable;
    }

    getDropDownsToRender(dropDowns: IDropDown[], dropDownChanged: IDropDown | null, selectedItem: IDropDownItem | null): IDropDown[] {
        let dropDownsToRender: IDropDown[] = new Array() as IDropDown[];
        let parentDropDowns: IDropDown[] = dropDowns.filter(function (row: IDropDown): any { return row.parentDropDownItemId == null; });
        this.addChildDropDowns(dropDowns, parentDropDowns, dropDownChanged, selectedItem, dropDownsToRender);
        return dropDownsToRender;
    }

    private addChildDropDowns(dropDowns: IDropDown[],
        parentDropDowns: IDropDown[],
        dropdownChanged: IDropDown | null,
        selectedItem: IDropDownItem | null,
        dropDownsToRender: IDropDown[],
        dropdownItemSelected: boolean = false): void {
        for (let dropdown of parentDropDowns) {
            dropDownsToRender.push(dropdown);
            if (dropdownItemSelected) {
                dropdown.selectedDropDownItem = dropdown.dropDownItems[0];
            }

            if (dropdownChanged != null && selectedItem != null && dropdownChanged.id === dropdown.id) {
                dropdown.selectedDropDownItem = selectedItem;
                dropdownItemSelected = true;
            }
            // for first time
            if (dropdownChanged == null && selectedItem == null && dropdown.selectedDropDownItem == null) {
                dropdown.selectedDropDownItem = dropdown.dropDownItems[0];
            }

            let children: IDropDown[] = dropDowns.filter(function (row: IDropDown): any {
                return row.parentDropDownItemId === dropdown.selectedDropDownItem.id && row.parentDashboardDropDownId === dropdown.id;
            });
            if (children.length > 0) {
                this.addChildDropDowns(dropDowns, children, dropdownChanged, selectedItem, dropDownsToRender, dropdownItemSelected);
            }

        }
    }
}